import React, { useEffect, useState } from 'react'
import styles from '../header/Header.module.css'
import ChatList from './ChatList'
import { useTranslation } from 'react-i18next'
import Avatar1 from '../../assets/new-right-menu/profile.svg'
import messages from '../../assets/new-right-menu/email.svg'
import setting from '../../assets/new-right-menu/settings.svg'
import exitIcon from '../../assets/new-right-menu/onOff.svg'
import avatar from '../../assets/images/avatar-1.jpg'
import Avatar2 from '../../assets/images/avatar-2.jpg'
import Avatar3 from '../../assets/images/avatar-3.jpg'
import { ROUTE_LOGIN, ROUTE_MESSENGER, ROUTE_USER_PROFILE } from '../../routes/routes-constants'
import { navigate } from '@reach/router'
import { getUserContainer } from 'container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { IUserService, LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import { User, UserDTO, fromModel } from '../../modules/users/models/User'
import { Avatar, Box, Button, Menu, MenuItem } from '@mui/material'
import style from '../avatar-profile/AvatarProfile.module.css'
import { getFileContainer } from '../../container/file-module'
import { FileService } from '../../modules/files/services/FileService'
import { FILE_SERVICE_KEY } from '../../modules/files'
import { emptyFileDTO } from '../../modules/files/models/FileDTO'
import { useProfilePhotoGlobalContext } from '../../common/utils/ProfilePhotoContext'
import { cloneDeep, stubArray } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { useGotifyWebSocket } from 'components/useGotifyWebSocket'

const filesContainer = getFileContainer()
const fileService = filesContainer.get<FileService>(FILE_SERVICE_KEY)
const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)
const userService = getUserContainer().get<IUserService>(USER_SERVICE_KEY)
type CustomAppBarProps = {
  onChange?: () => void
}

type NotificationGotify = {
  id: string
  title: string
  message: string
  createAd: Date
}

const NavRight = (props: CustomAppBarProps) => {
  const { t } = useTranslation()
  const [listOpen, setListOpen] = useState<boolean>(false)
  const [user, setUser] = useState<UserDTO>()
  const { profilePhoto, setProfilePhoto } = useProfilePhotoGlobalContext()
  const [socket, setWebsocket] = useState<WebSocket>()
  const [notifications, setNotifications] = useState<NotificationGotify[]>([])
  const [count, setCount] = useState<number>(0)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const loggedUser = loggedUserService.get()

  /*useEffect(() => {
    if (!socket) {
      setWebsocket(
          new WebSocket(
              `ws://backend-gotify.visualtis.com/stream?token=CXwS_5hqEgJV1xZ`
          )
      )
    }
  }, [])*/

  // const { connected, notificationPermission, requestNotificationPermission } = useGotifyWebSocket({
  //   serverUrl: 'http://localhost:8080',
  //   //serverUrl: 'https://backend-gotify.visualtis.com',
  //   token: user?.notificationsToken ?? '',
  //   onMessage: (msg) => {
  //     console.log(msg)
  //   },
  // })

  // // Solicitar permisos manualmente si es necesario
  // if (notificationPermission === 'default') {
  //   requestNotificationPermission()
  // }

  // const connectWebSocket = useGotifyWebSocket({
  //   serverUrl: 'http://localhost:8080',
  //   //serverUrl: 'https://backend-gotify.visualtis.com',
  //   token: user?.notificationsToken ?? 'CioNI-oX2LdM84F',
  //   onMessage: (msg) => {
  //     console.log(msg)
  //   },
  // })

  const { connected, notificationPermission, requestPermissions } = useGotifyWebSocket({
    serverUrl: 'https://backend-gotify.visualtis.com',
    token: user?.notificationsToken ?? '',
    onMessage: (message) => {
      console.log(user?.notificationsToken, 'Nuevo mensaje:', message, connected)
    },
  })

  // Solicitar permisos manualmente si es necesario
  if (notificationPermission !== 'granted') {
    console.log('Request PERMISSIONS')
    requestPermissions()
  } else {
    console.log('Permissions yes')
  }

  // useEffect(() => {
  //   //const ws = new WebSocket(`ws://localhost/stream?token=CCyYe9JUcw0aFq7`)
  //   const ws = new WebSocket(`ws://backend-gotify.visualtis.com/stream?token=CsKvguTRZZhkGej}`)
  //   ws.onopen = () => {
  //     console.log('Successfully Connected')
  //   }
  //   ws.onmessage = (msg) => {
  //     if (notifications) {
  //       let m = JSON.parse(msg.data)
  //       const notification = cloneDeep<NotificationGotify[]>(notifications)
  //       let mAux = notifications
  //       mAux.push({
  //         id: uuidv4(),
  //         title: m.title,
  //         message: m.message,
  //         createAd: m.createAd,
  //       })

  //       setNotifications(mAux)
  //     }
  //   }
  //   ws.onclose = (event) => {
  //     console.log('Socket Closed Connection: ', event)
  //   }
  //   ws.onerror = (error) => {
  //     console.log('Socket Error: ', error)
  //   }
  //   return () => {
  //     ws.close()
  //   }
  // }, [user])

  /*let connect = () => {
    //console.log('connecting')

    if (socket) {
      socket.onopen = () => {
        // console.log('Successfully Connected')
      }
    }

    if (socket) {
      socket.onmessage = (msg) => {
        if (notifications) {
          let m = JSON.parse(msg.data)
          const notification = cloneDeep<NotificationGotify[]>(notifications)
          let mAux = notifications
          mAux.push(
             {
                id: uuidv4(),
                title: m.title,
                message: m.message,
                createAd: m.createAd
              }
          )
          console.log('notification', notification)

          setNotifications(mAux)

        }
      }
    }

    if (socket) {
      socket.onclose = (event) => {
        console.log('Socket Closed Connection: ')
      }
    }

    if (socket) {
      socket.onerror = (error) => {
        console.log('Socket Error: ', error)
      }
    }
  }

  useEffect(() => {
    if (socket) {
      connect()
    }
  }, [socket])*/

  useEffect(() => {
    if (!loggedUser?.id) return
    //cargamos la foto de perfil
    fileService.getProfilePhotoByUserID(loggedUser.id).subscribe((res) => {
      setProfilePhoto(res || emptyFileDTO(''))
    })

    userService.getByID(loggedUser?.id).subscribe((res) => {
      console.log('>>>>DATA USER: ', res)
      res && setUser(fromModel(res))
    })
  }, [])

  const handleSetMenuSelected = (menuSelected: string) => {
    navigate(menuSelected)
  }

  const handleLogout = () => {
    loggedUserService.logout()
    navigate(ROUTE_LOGIN).then()
    props.onChange && props.onChange()
  }
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {/*<Dropdown className={styles.navRightContainer} style={{ marginRight: '-1.5%' }}>
        <Dropdown.Toggle variant="link" id="dropdown-basic" style={{ color: 'black' }}>
          <i className="icon feather icon-bell" />
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight className="notification">
          <div className={styles.notiHead}>
            <h6 className="d-inline-block m-b-0">Notifications</h6>
            <div className="float-right">
              <a className="m-r-10">mark as read</a>
              <a className={styles.clearAll}>clear all</a>
            </div>
          </div>
          <ul className="noti-body">
            <li className="n-title">
              <p className="m-b-0">NEW</p>
            </li>
            <li className="notification">
              <div className="media">
                <img className="img-radius" src={Avatar1} alt="Generic placeholder" />
                <div className="media-body">
                  <p>
                    <strong>John Doe</strong>
                    <span className="n-time text-muted">
                      <i className="icon feather icon-clock m-r-10" />
                      30 min
                    </span>
                  </p>
                  <p>New ticket Added</p>
                </div>
              </div>
            </li>
            <li className="n-title">
              <p className="m-b-0">EARLIER</p>
            </li>
            <li className="notification">
              <div className="media">
                <img className="img-radius" src={Avatar2} alt="Generic placeholder" />
                <div className="media-body">
                  <p>
                    <strong>Joseph William</strong>
                    <span className="n-time text-muted">
                      <i className="icon feather icon-clock m-r-10" />
                      30 min
                    </span>
                  </p>
                  <p>Prchace New Theme and make payment</p>
                </div>
              </div>
            </li>
            <li className="notification">
              <div className="media">
                <img className="img-radius" src={Avatar3} alt="Generic placeholder" />
                <div className="media-body">
                  <p>
                    <strong>Sara Soudein</strong>
                    <span className="n-time text-muted">
                      <i className="icon feather icon-clock m-r-10" />
                      30 min
                    </span>
                  </p>
                  <p>currently login</p>
                </div>
              </div>
            </li>
          </ul>
          <div className="noti-footer">
            <a>show all</a>
          </div>
        </Dropdown.Menu>
      </Dropdown>*/}
      {/*<Dropdown className={styles.navRightContainer} style={{ marginRight: '-1.5%' }}>
        <Dropdown.Toggle
          variant="link"
          className="displayChatbox"
          onClick={() => setListOpen(true)}>
          <i className="icon feather icon-mail" style={{ color: 'black' }} />
        </Dropdown.Toggle>
      </Dropdown>*/}

      {
        <Box className={styles.navRightContainer} style={{ marginRight: '-1%' }}>
          <div>
            <img
              src={messages}
              alt="messages"
              className={styles.iconMenu}
              onClick={() => handleSetMenuSelected(ROUTE_MESSENGER)}
            />
          </div>
          <Button
            onClick={handleClick}
            style={{
              color: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 0,
              margin: 20,
            }}
          >
            <Avatar
              style={{ width: '100%!important', height: '100%!important' }}
              sx={{ width: '3rem', height: '3rem', marginRight: 1, objectFit: 'cover' }}
              className={style.profilepic__image}
              alt="Remy Sharp"
              src={
                profilePhoto.data.length > 0
                  ? `data:image/jpg;base64, ${profilePhoto.data}`
                  : Avatar1
              }
            />
          </Button>
          <Box className="pro-body">
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              sx={{
                '& .MuiPaper-root': {
                  borderRadius: '13px',
                  transform: 'translate(-65px, 7px) !important',
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  handleSetMenuSelected(ROUTE_USER_PROFILE)
                }}
                className={styles.menuItem}
              >
                <img style={{ marginRight: 8 }} src={setting} alt={'profile'} />{' '}
                <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: 18 }}>
                  {t('profile')}
                </span>
              </MenuItem>
              <MenuItem onClick={handleLogout} className={styles.menuItem}>
                <img style={{ marginRight: 16 }} src={exitIcon} alt={'exit'} />{' '}
                <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: 18 }}>{t('exit')}</span>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      }
      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
    </>
  )
}

export default NavRight
